import React from 'react';
import { Link } from 'react-router-dom';

const About = () => (
  <div className="bg-sans_bone">
    <section className="sans-section">
      <div className="sans-container max-w-4xl">
        <div className="sans-label mb-6">Our story</div>
        <h1 className="sans-h1">Ayurveda deserves better<br/>than shortcuts.</h1>
        <div className="sans-rule mt-10" />
        <div className="mt-12 space-y-6 text-lg leading-relaxed text-sans_ink">
          <p>Saans Ayurved began with a simple observation: authentic Ayurveda is being lost between two extremes — mystical marketing on one side, and clinical over-simplification on the other.</p>
          <p>Classical Ayurveda is neither. It is a rigorous, elegant, thousand-year-old system of understanding the body-mind. It respects individuality, honors nature, and takes time.</p>
          <p>We built Saans Ayurved to bring classical Ayurveda to modern lives — with the care, patience, and precision it deserves. No shortcuts, no gimmicks, no diet fads.</p>
          <p>Every consultation is with a qualified Ayurvedic physician. Every formulation is rooted in classical texts. Every recommendation is personal.</p>
          <p className="text-sans_mute italic font-serif text-xl mt-10">This is only the beginning.</p>
        </div>
        <div className="mt-16 flex flex-wrap gap-4">
          <Link to="/assessment" className="sans-btn-primary">Start the free assessment</Link>
          <Link to="/consultation" className="sans-btn-secondary">Book a consultation</Link>
        </div>
      </div>
    </section>
  </div>
);

export default About;
